import axios from "axios";

const state = {
    loding: false,
    listSuperCategories: [],
    listCategories: [],
    listDeals: {pathLogo: '', pathPromotion: '', deals: []}
}
const getters = {
    loading: (state) => state.loding,
    listSuperCategories: (state) => state.listSuperCategories,
    listCategories: (state) => state.listCategories,
    superCategoryByCategoryId: (state) => (categoryId) => {
        return state.listSuperCategories.categories.find((superCategory) => {
            return superCategory.subCat.find((subCat) => subCat.id === categoryId)
        })
    },
    categoryById: (state) => (categoryId) => {
        return state.listCategories.find(({id}) => id === categoryId)
    },
    listDeals: (state) => state.listDeals,
    listPromotion: (state) => {
        let deals = []
        if (state.listDeals.deals.length > 0) {
            state.listDeals.deals.forEach((item) => {
                if (item.promotion !== undefined) {
                    item.promotion.rating = parseInt(item.rating)
                    item.promotion.promotionSaleCount = item.promotion_sale_count
                    item.promotion.promotionView = item.promotion_view
                    item.promotion.days = item.days
                    deals.push(item.promotion)
                }
            })
        }
        return deals
    },
    listPartner: (state) => {
        let deals = []
        if (state.listDeals.deals.length > 0) {
            state.listDeals.deals.forEach((item) => {
                if (item.partner) deals.push(item.partner)
            })
        }
        return deals
    },
    promotionById: (state, getters) => (promoId) => {
        return getters.listPromotion.find(({id}) => id === promoId)
    },
    partnerById: (state, getters) => (partnerId) => {
        return getters.listPartner.find(({id}) => id === partnerId)
    }
}

const mutations = {
    SET_LOADING(state) {
        state.loding = !state.loding
    },
    SET_LIST_SUPER_CATEGORIES(state, listSuperCategory) {
        state.listSuperCategories = listSuperCategory
    },
    SET_LIST_CATEGORIES(state, listCategory) {
        state.listCategories = listCategory
    },
    SET_LIST_DEALS(state, listDeals) {
        state.listDeals = listDeals
    },
    SET_PROMOTION_IS_VIEW(state, promoId) {
        if (state.listDeals.deals.length > 0) {
            for (let i = 0; i < state.listDeals.deals.length; i++) {
                let item = state.listDeals.deals[i]
                if (item.promotion !== undefined && item.promotion.id === promoId) {
                    state.listDeals.deals[i].promotion.promotionView += 1
                }
            }
        }
    }
}
const actions = {
    async searchAllSuperCategory(context) {
        context.commit('SET_LOADING')
        const uriApp = context.rootGetters.uriApp
        await axios.get(uriApp + `/api/categories`).then((response) => {
            context.commit('SET_LIST_SUPER_CATEGORIES', {
                categories: response.data['super_cat'],
                path: response.data['url_image']
            })
            context.commit('SET_LIST_CATEGORIES', response.data['sub_cat'])
        }).catch((error) => {
            console.error(error)
        })
        context.commit('SET_LOADING')
    },
    async searchAllDeal(context) {
        context.commit('SET_LOADING')
        const uriApp = context.rootGetters.uriApp
        await axios.get(uriApp + `/api/deals`).then((response) => {
            const {data, log_url, promotion_url} = response.data
            context.commit('SET_LIST_DEALS', {
                pathLogo: log_url,
                pathPromotion: promotion_url,
                deals: data
            })
        }).catch((error) => {
            console.error(error)
        })
        context.commit('SET_LOADING')
    },
}
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true,
    strict: true
}
